import { colorsHex } from 'utils/formatterDatesScheduled';

export const getColorMarker = (position: string): colorsHex => {
	if (position === '0') {
		return '#8CF07E';
	}
	if (position === '1') {
		return '#1AB0E6';
	}
	if (position === '2') {
		return '#5082C2';
	}
	if (position === '3') {
		return '#C22A58';
	}

	return '#8CF07E';
};
